// Registers only the ECharts pieces the app uses, so the full echarts
// bundle (every chart type and renderer) stays out of the build.
// Import this module instead of 'echarts'.
import { BarChart, LineChart, PieChart, ScatterChart } from 'echarts/charts'
import {
  DataZoomComponent,
  GridComponent,
  LegendComponent,
  MarkLineComponent,
  MarkPointComponent,
  ToolboxComponent,
  TooltipComponent
} from 'echarts/components'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'

use([
  BarChart,
  LineChart,
  PieChart,
  ScatterChart,
  DataZoomComponent,
  GridComponent,
  LegendComponent,
  MarkLineComponent,
  MarkPointComponent,
  ToolboxComponent,
  TooltipComponent,
  CanvasRenderer
])

export { graphic, init } from 'echarts/core'
export type { ECharts, Payload } from 'echarts/core'
export type {
  BarSeriesOption,
  EChartsOption,
  LineSeriesOption,
  MarkLineComponentOption,
  SeriesOption
} from 'echarts'
